if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.paymentButtons = this.querySelector(
          ".product-form__buttons.test-class"
        );
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        console.log(
          "x",
          this.cart.getSectionsToRender().map((section) => section.id)
        );

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log(response);
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }


      toggleSubmitButton(disable = true, text) {
        if (disable) {
          // Enable the submit button by removing the 'disabled' attribute
          this.submitButton.removeAttribute("disabled");

          this.submitButton.style.display = "none";
          document.querySelector(".notify-me-wrapper").classList.remove("hidden");
          document.querySelector(".shopify-payment-button").classList.add("hidden");

          if (text) this.submitButtonText.textContent = text;
        } else {
          // Re-enable the submit button (if disabled)
          this.submitButton.removeAttribute("disabled");

          this.submitButton.style.display = "block";
          document.querySelector(".notify-me-wrapper").classList.add("hidden");
          document.querySelector(".shopify-payment-button").classList.remove("hidden");

          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
      
      // toggleSubmitButton(disable = true, text) {
      //   if (disable) {
      //     // Enable the submit button by removing the 'disabled' attribute
      //     this.submitButton.removeAttribute("disabled");

      //     // Optional: hide payment buttons and style changes (uncomment if needed)
      //     // this.submitButton.style.setProperty('display', 'none', 'important');
      //     // this.paymentButtons.style.setProperty('display', 'none', 'important');

      //     // If the button has the 'product-form__submit' class, change to a different class
      //     if (this.submitButton.classList.contains("product-form__submit")) {
      //       this.submitButton.classList.remove("product-form__submit");
      //       this.submitButton.classList.add("notify-stock-button-x");
      //     }

      //     // Update button text if needed
      //     if (text) this.submitButtonText.textContent = text;
      //   } else {
      //     // Re-enable the submit button (if disabled)
      //     this.submitButton.removeAttribute("disabled");

      //     // Optional: Reset display styles (uncomment if needed)
      //     // this.submitButton.style.display = '';
      //     // this.paymentButtons.style.display = '';

      //     // If the button has the 'notify-stock-button-x' class, switch it back to the original
      //     if (this.submitButton.classList.contains("notify-stock-button-x")) {
      //       this.submitButton.classList.remove("notify-stock-button-x");
      //       this.submitButton.classList.add("product-form__submit");
      //     }

      //     // Restore the default button text (using a predefined string)
      //     this.submitButtonText.textContent = window.variantStrings.addToCart;
      //   }
      // }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
